import { SELECT_PRODUCT, SET_EMAIL } from './constants'

export const setProductName = (productName) => (dispatch) => {
  dispatch({
    type: SELECT_PRODUCT,
    payload: productName,
  })
}
export const setUserEmail = (email) => (dispatch) => {
  dispatch({
    type: SET_EMAIL,
    payload: email,
  })
}
